module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-btn', {
    staticStyle: {
      "display": "none"
    },
    nativeOn: {
      "click": function($event) {
        _vm.err($event)
      }
    }
  }, [_vm._v("\n    error\n  ")]), _vm._v(" "), (!_vm.authenticated) ? [_c('main', [_c('v-container', [_c('router-view', {
    attrs: {
      "name": "auth"
    }
  })], 1)], 1)] : [_c('v-navigation-drawer', {
    attrs: {
      "clipped": "",
      "permanent": "",
      "dark": "",
      "mini-variant": _vm.mini
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return (item.show.indexOf(_vm.user.company.type) > -1) ? _c('router-link', {
      key: item.title,
      staticClass: "list__tile",
      attrs: {
        "title": item.title,
        "tag": "a",
        "to": item.route
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("\n              " + _vm._s(item.icon) + "\n            ")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])], 1)], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "tender__color",
    attrs: {
      "fixed": ""
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "100%"
    },
    attrs: {
      "src": require("../static/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v("\n      " + _vm._s(_vm.user.name) + " (" + _vm._s(_vm.user.company.name) + ")\n      "), _c('v-btn', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("выйти")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "slot": "loading",
      "xs1": ""
    },
    slot: "loading"
  }, [_c('v-progress-circular', {
    staticClass: "cyan--text lighten-3",
    attrs: {
      "indeterminate": "",
      "size": 100,
      "width": 7
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e()], 1)], 1)], 1)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.success.enabled),
      callback: function($$v) {
        _vm.$set(_vm.success, "enabled", $$v)
      },
      expression: "success.enabled"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.success.message) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.error.enabled),
      callback: function($$v) {
        _vm.$set(_vm.error, "enabled", $$v)
      },
      expression: "error.enabled"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "error": "",
      "value": "true"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.error.message) + "\n        ")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-635ac153"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 152
// module chunks = 13